export default {
  glow: {
    active: 'Active',
    blankText: '(blank)',
    cancel: 'Cancel',
    clearAll: 'Clear all',
    close: 'Close',
    confirm: 'Confirm',
    copied: 'Copied',
    copyFailed: 'Copy failed',
    copyValue: 'Copy {{value}}',
    deselectAll: 'Deselect all',
    dismiss: 'Dismiss',
    event: {
      serviceUpgrade: {
        title: 'Service upgrade',
        curbside: 'Curbside',
        indoor: 'Indoor',
        deliveryDate: 'Delivery date'
      },
      shorterTimeWindow: {
        title: 'Shorter time window'
      }
    },
    emptyStates: {
      notFoundTitle: 'No results found',
      notFoundDescription: 'We could not find any results. Please try adjusting you search filter.',
      initialTitle: 'No information yet',
      successTitle: 'Good job'
    },
    filter: 'Filter',
    filterOverlay: {
      filter: 'Filter',
      activeFilterCount: '{{count}} active filter',
      activeFilterCount_other: '{{count}} active filters',
      clearFilter: 'Clear filter'
    },
    from: 'From',
    goToPage: 'Go to page',
    group: 'Group',
    invalidDateFormat: 'Invalid date format',
    openCalendar: 'Open calendar',
    loading: 'Loading',
    no: 'No',
    none: 'None',
    notActivated: 'Not activated',
    of: 'of',
    orderOfTable: 'Order of column headings',
    orderOfTableDescription: 'Choose the preferred order for the column headers by dragging and dropping.',
    fixedTableHeadersDescription: 'The following column headers are fixed and cannot be removed or reordered.',
    page: 'Page',
    search: 'Search',
    selectAll: 'Select all',
    selectAllCount: 'Select all ({{count}})',
    selectAllOnPage: 'Select all on page ({{count}})',
    settings: 'Settings',
    to: 'To',
    yes: 'Yes',
    accordionMessage: {
      error: '{{count}} error messages',
      warning: '{{count}} warning messages',
      info: '{{count}} info messages',
      general: '{{count}} messages'
    },
    invalidRegistrationNumber: 'Please enter a valid registration number containing only letters and numbers',
    invalidRegistrationNumber_SE: 'Invalid format. Expected: ABC123 or ABC12D',
    invalidRegistrationNumber_DK: 'Invalid format. Expected: AB12345',
    invalidRegistrationNumber_NO: 'Invalid format. Expected: AB1234 or AB12345'
  }
}
